import { resourceSliceFactory } from "infrastructure/store/state";
import { MenuItem } from "consts/waMessaging";
import type { WaMessagingState } from "./types";

const state: WaMessagingState = {
    [MenuItem.WaMessages]: resourceSliceFactory(),
    [MenuItem.WaMessagesSetups]: resourceSliceFactory(),
    [MenuItem.PhoneVerifications]: resourceSliceFactory(),
    [MenuItem.FailedPhoneVerifications]: resourceSliceFactory(),
    [MenuItem.WaTemplatesSetups]: resourceSliceFactory()
};

export const sliceToken = 'waMessaging';

export default state;
